.section {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-1);
}

.tip {
  margin: 0;
  color: var(--hcr-content-secondary-color);
}
